import { render, staticRenderFns } from "./categoryStatistics.vue?vue&type=template&id=b442f916&scoped=true"
import script from "./categoryStatistics.vue?vue&type=script&lang=js"
export * from "./categoryStatistics.vue?vue&type=script&lang=js"
import style0 from "./categoryStatistics.vue?vue&type=style&index=0&id=b442f916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b442f916",
  null
  
)

export default component.exports